<template>
    <div>
        <div id="camera">
            <div>
                <video ref="video" id="video" width="60%" height="60%" autoplay />
            </div>
            <div>
                <v-btn rounded color="primary" v-if="photo==null" id="snap" v-on:click="capture()">Capture Photo</v-btn>
            </div>
            <canvas ref="canvas" id="canvas" width="300" height="300" />
            <template v-if="photo!=null">
                Close this window
            </template>
        </div>
    </div>
</template>
<script>
    import axios from "axios";
    export default {
        name: "Camera",
        data() {
            return {
                video: {},
                canvas: {},
                captures: [],
                photo:null,
                
            };
        },
        mounted() {
           this.video = this.$refs.video;
            if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
                navigator.mediaDevices.getUserMedia({ video: true }).then((stream) => {
                    video.srcObject = stream;
                    video.play();
                    video.onplay = function () {};
                    this.video.play();
                });
            }
        },
        methods: {
            stop(){
            if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
                navigator.mediaDevices.getUserMedia({ video: true }).then((stream) => {
                    video.pause();
                    video.srcObject = null;
                    stream.getTracks().forEach(function(track) {
                        track.stop();
                    });
                    video.stop;
                    stream = null;
                });
            }
             this.photo = localStorage.getItem("awspath") + localStorage.getItem("photo_path")  + localStorage.getItem("photo_name")
            },
            srcToFile(src, fileName, mimeType) {
                return fetch(src)
                    .then(function (res) {
                        return res.arrayBuffer();
                    })
                    .then(function (buf) {
                        return new File([buf], fileName, { type: mimeType });
                    });
            },
            capture() {
                //alert("in caprure");
                this.canvas = document.getElementById("canvas");
                this.canvas = this.$refs.canvas;
                var context = this.canvas.getContext("2d").drawImage(this.video, 0, 0, this.canvas.width, this.canvas.height);
                this.saveimage();
                // this.captures.push(canvas.toDataURL("image/webp"));
            },
            saveimage() {
              
                var image;
                if (document.getElementById("canvas") != null) {
                    image = document.getElementById("canvas").toDataURL("image/png");
                }
                let fd = new FormData();
                this.srcToFile(image, "logo.png", "image/png")
                    .then(function (file) {
                        console.log("file....." + file.size);
                        fd.append("doc", file);
                        axios
                            .post("/visitorManagement/capturePhoto", fd, { headers: { "Content-Type": "multipart/form-data" } })
                            .then( (res) =>{
                            console.log("SUCCESS!!");
                                if(res.data.flag=="YES"){
                                    let photo_path = res.data.photo_path
                                    let photo_name = res.data.photo_name
                                    localStorage.setItem("photo_path",photo_path)
                                    localStorage.setItem("photo_name",photo_name)
                                    alert("Photo captured successfully. Close this window.")
                                }
                                else{
                                    alert("Something went wrong!!!")
                                }
                            })
                            .catch( (error)=> {
                                console.log("FAILURE!!",error);
                            });
                    })
                    .then((res) => {
                        
                        this.stop();
                        
                    }) 
                    .catch((error) => {
                    })
                    .finally(() => {
                    });
            },
           
        },
    };
</script>
<style>
    #camera {
        text-align: center;
        color: #2c3e50;
    }
    #video {
        background-color: #000000;
    }
    #canvas {
        display: none;
    }
    li {
        display: inline;
        padding: 5px;
    }
</style>